import { Button, Navbar } from 'flowbite-react';
import { Link } from 'react-scroll';
import logo from '../Images/logo.avif'

export default function Nav() {
    return (
        <Navbar className='sticky inset-0' sticky rounded>
            <Navbar.Brand >
                <img src={logo} className="mr-3 h-6 sm:h-9" alt="Logo" />
                <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">ClearViva</span>
            </Navbar.Brand>
            <div className="flex md:order-2">
                <Button color='failure'>
                    <Link
                        activeClass="active"
                        to="footer"
                        spy={true}
                        smooth={true}
                        offset={-70} // Adjust the offset as needed
                        duration={1500} // Adjust the duration of the scroll animation
                    >
                        Reach Out
                    </Link>
                </Button>
                <Navbar.Toggle />
            </div>
            <Navbar.Collapse>
                <Navbar.Link className='cursor-pointer' >
                    <Link
                        activeClass="active"
                        to="banner"
                        spy={true}
                        smooth={true}
                        offset={-1000} // Adjust the offset as needed
                        duration={1500} // Adjust the duration of the scroll animation
                    >
                        Home

                    </Link>
                </Navbar.Link>
                <Navbar.Link className='cursor-pointer'>
                    <Link
                        activeClass="active"
                        to="partOne"
                        spy={true}
                        smooth={true}
                        offset={-70} // Adjust the offset as needed
                        duration={500} // Adjust the duration of the scroll animation
                    >
                        Part 1

                    </Link>
                </Navbar.Link>
                <Navbar.Link className='cursor-pointer'>
                    <Link
                        activeClass="active"
                        to="partTwo"
                        spy={true}
                        smooth={true}
                        offset={-40} // Adjust the offset as needed
                        duration={800} // Adjust the duration of the scroll animation
                    >
                        Part 2

                    </Link>
                </Navbar.Link>
                <Navbar.Link className='cursor-pointer'>
                    <Link
                        activeClass="active"
                        to="miniProject"
                        spy={true}
                        smooth={true}
                        offset={-70} // Adjust the offset as needed
                        duration={800} // Adjust the duration of the scroll animation
                    >
                        PHP 

                    </Link>
                </Navbar.Link>

            </Navbar.Collapse>
        </Navbar>
    );
}
